<template lang="pug">
  div.apply-bulk.px-4.pt-2
    div.label.basic600--text.text-uppercase {{ $t('apply_to_all', { text: applyTitle }) }}
    div.d-flex.align-center.justify-space-between.my-2
      v-form(ref="form")
        v-text-field.centered-input(v-model.number="value" v-if="selectedSetting === 'price'" :disabled="isFetching" hide-details="auto" dense outlined height="40" background-color="basic200" :prefix="$currency.symbol" type="number" :rules="rules.has_quantity")
        v-text-field.centered-input(v-model.number="value" v-if="selectedSetting === 'weight'" :disabled="isFetching" hide-details="auto" dense outlined height="40" background-color="basic200" suffix="kg" type="number" :rules="rules.weight")
        v-text-field.centered-input(v-model.number="value" v-if="selectedSetting === 'inventory'" :disabled="isFetching" hide-details="auto" dense outlined height="40" background-color="basic200" type="number" :rules="rules.number_not_empty")
      v-btn.ml-2(outlined dense style="background-color: var(--v-infoT08); border: solid 1px var(--v-info500)" :disabled="isFetching" @click="clickApply")
        .button-AA-medium.info500--text {{ $t('apply') }}
    div.d-flex.align-center
      eva-icon.mb-n1.mr-2(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="24" height="24")
      div.c1.basic600--text {{ $t('this_will_applied_all', { text: applyTitle }) }}
</template>

<script>
export default {
  name: 'BundleBulkApplyAll',
  props: {
    isFetching: {
      type: Boolean
    },
    selectedSetting: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      value: null,
      rules: {
        number_not_empty: [v => v !== null || 'This field is required', v => v !== '' || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v > 0 || 'Price should be more than 0'],
        weight: [v => v !== null || 'This field is required', v => v !== '' || 'This field is required', v => v >= 0 || 'Weight should be positive', v => v <= 60 || 'Weight should not be above 60 KG']
      }
    }
  },
  computed: {
    applyTitle() {
      switch (this.selectedSetting) {
        case 'price':
          return this.$t('price')

        case 'weight':
          return this.$t('weight')

        case 'inventory':
          return this.$t('amount')

        default:
          return false
      }
    }
  },
  methods: {
    clickApply() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.$emit('updateData', this.value)
    }
  },
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.value-changed {
  border: 1px solid var(--v-success500);
}
</style>

<i18n>
{
  "en": {
    "price": "price",
    "weight": "weight",
    "amount": "amount",
    "apply_to_all": "Apply {text} to all",
    "this_will_applied_all": "This {text} will be applied to all products in this page"
  },
  "id": {
    "price": "Harga",
    "weight": "Berat",
    "amount": "Jumlah",
    "apply_to_all": "Terapkan {text} kepada semua",
    "this_will_applied_all": "{teks} ini akan diterapkan ke semua produk di halaman ini"
  }
}
</i18n>